export default "__VITE_ASSET__5882cb51__"